import ReactGA from 'react-ga4';

const GA_MEASUREMENT_ID = process.env.REACT_APP_GA_MEASUREMENT_ID;

export const initGA = () => {
  if (GA_MEASUREMENT_ID) {
    ReactGA.initialize(GA_MEASUREMENT_ID);
  }
};

export const setUserId = (userId: string) => {
  if (GA_MEASUREMENT_ID) {
    ReactGA.set({ userId });
  }
};

type EventName =
  | 'activity_start'
  | 'activity_stop'
  | 'activity_pause'
  | 'activity_resume'
  | 'interval_edit'
  | 'interval_delete'
  | 'activity_create'
  | 'activity_edit'
  | 'export'
  | 'login'
  | 'logout'
  | 'delete_account'
  | 'view_change'
  | 'date_range_change'
  | 'grouping_change';

export const trackEvent = (eventName: EventName) => {
  if (GA_MEASUREMENT_ID) {
    ReactGA.event(eventName);
  }
};

export const trackPageView = (path: string) => {
  if (GA_MEASUREMENT_ID) {
    ReactGA.send({ hitType: 'pageview', page: path });
  }
};
